import Button from "react-bootstrap/Button";
import { Modal, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useEffect, useState } from "react";
import ContentGroupsPicker from "./Pickers/ContentGroupsPicker";
import { axiosInstance } from "../auth/Auth";
import { Search } from "react-bootstrap-icons";

export default function MassAddContentGroupsModal({ onClose, show, radioId, sortedItems, triggerFormSubmit, filterFunction }) {
    const [selectedContentGroups, setSelectedContentGroups] = useState([]);
    const [keywords, setKeywords] = useState([]);
    const [keywordInput, setKeywordInput] = useState("");

    useEffect(() => {
        if (!show) {
            setSelectedContentGroups([]);
            setKeywords([]);
            setKeywordInput("");
        }
    }, [show]);

    function handleKeywordChange(e) {
        const value = e.target.value;
        setKeywordInput(value);

        const list = value
            .split(",")
            .map(k => k.trim())
            .filter(k => k.length > 0);

        setKeywords(list);
    }

    async function handleConfirm() {
        try {
            const breakIds = sortedItems.map(item => item.break_id);
            const contentGroups = selectedContentGroups.map(item => item.group_id);

            await axiosInstance.post(`/content_testing/breaks/bulk_update/`, {
                break_ids: breakIds,
                group_ids: contentGroups,
                keywords: keywords,
            });

            triggerFormSubmit();
        } catch (error) {
            console.error(error);
        }

        setSelectedContentGroups([]);
        setKeywords([]);
        setKeywordInput("");
        onClose();
    }

    return (
        <Modal show={show} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton closeVariant={"white"}>
                <Modal.Title>Bulk Update Keywords and/or Content Groups</Modal.Title>
            </Modal.Header>
            <Modal.Body className="top-modal">
                <div className="mb-3">
                    Adding keywords and/or content groups will apply it to all currently filtered and visible breaks in the table. This action cannot be undone.
                </div>

                <Row className="row-gap-3 mb-3 ">
                    <Form.Group as={Col} className="col-12 col-xl-12">
                        <Form.Label className="d-inline-flex">Keywords</Form.Label>
                        <InputGroup>
                            <Form.Control value={keywordInput} onChange={handleKeywordChange} placeholder="Add keywords — use commas to separate" />
                        </InputGroup>
                    </Form.Group>
                </Row>

                <ContentGroupsPicker
                    formData={{ contentGroups: selectedContentGroups }}
                    setFormData={({ contentGroups }) => setSelectedContentGroups(contentGroups)}
                    name="moduleName"
                    placeholder="Select Content Groups"
                    filterFunction={filterFunction}
                    labelVisible={true}
                    customClass="col-12 col-xl-12"
                    open={true}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="ra-yellow" onClick={handleConfirm}>
                    Add
                </Button>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
